import Auth from './auth'

import './middleware'

// Active chemes
import scheme_003d9a64 from './schemes/local.js'
import scheme_24a28d03 from './schemes/JwtScheme.js'

export default function (ctx, inject) {
  // Options
  const options = {"resetOnError":false,"scopeKey":"scope","rewriteRedirects":true,"fullPathRedirect":false,"watchLoggedIn":true,"redirect":{"login":"/login","logout":"/","home":"/","callback":"/login"},"vuex":{"namespace":"auth"},"cookie":{"prefix":"auth.","options":{"path":"/"}},"localStorage":{"prefix":"auth."},"token":{"prefix":"_token."},"refresh_token":{"prefix":"_refresh_token."},"defaultStrategy":"local"}

  // Create a new Auth instance
  const $auth = new Auth(ctx, options)

  // Inject it to nuxt context as $auth
  inject('auth', $auth)

  // Register strategies

  // local
  $auth.registerStrategy('local', new scheme_003d9a64($auth, {"endpoints":{"login":{"url":"/api/auth/login","method":"post","propertyName":"token"},"logout":{"url":"/api/auth/logout","method":"post"},"user":{"url":"/api/auth/user","method":"get","propertyName":"user"}},"_name":"local"}))

  // jwt
  $auth.registerStrategy('jwt', new scheme_24a28d03($auth, {"endpoints":{"login":{"url":"/auth/public/signIn","method":"post"},"user":{"url":"/auth/me?siteId=homepage","method":"get","propertyName":"data"},"logout":{"url":"/auth/signOut","method":"post"},"refresh":{"url":"/auth/public/refreshToken","method":"get"}},"_name":"jwt"}))

  // Initialize auth
  return $auth.init().catch(error => {
    if (process.browser) {
      console.error('[ERROR] [AUTH]', error)
    }
  })
}
